import { GridCellParams, GridColDef, GridValueFormatterParams } from '@mui/x-data-grid'
import { t } from 'i18next'
import React from 'react'
import DataGridActions from '../../components/global/DataGridActions'
import { useDispatch } from 'react-redux'
import I18nDataGrid from '../../components/global/I18nDataGrid'
import { UseTrainingType } from '../../hooks/useTrainingType'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import { TUser } from '../../shared/types/user.type'
import { Box, Button, LinearProgress } from '@mui/material'
import { setTrackModal, setTrainingTypeModal, setTrainingTypeToEdit } from '../../store/reducers/modal.reducer'
import { isEmpty, toNumber } from 'lodash'
import { useQueryClient } from 'react-query'
import { toast } from 'react-toastify'
import { Add } from '@mui/icons-material'
import { TTrainingType } from '../../shared/types/training.type'

function MyTrainingTypes() {
  const auth = useSelector<RootState>(state => state.user.user) as TUser | null
  const isUserLoading = useSelector<RootState>(state => state.user.isUserLoading) as boolean
  const { isLoading, isError, trainingTypes, remove, isDeleting } = UseTrainingType(!isUserLoading, auth?.['@id'])

  const dispatch = useDispatch()



  const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID' },
    {
      field: 'display_name',
      headerName: t('name'),
      flex: 1,
      valueFormatter: (param: GridValueFormatterParams) => {
        return param.value ?? '-'
      }
    },
    {
      headerName: t('settings:actions'),
      field: 'action',
      flex: 1,
      renderCell: (params: GridCellParams<TTrainingType>) =>

        !params.row.trainer ? null : <DataGridActions
          deleteTitle='trainingTypes:delete'
          deleteSubtitle='trainingTypes:deleteMessage'
          onEdit={() => {
            dispatch(setTrainingTypeToEdit(params.row))
            dispatch(setTrainingTypeModal(true))
          }
          }
          isDeleting={isDeleting}
          onDelete={() => { remove(toNumber(params.id)) }}

        />
    }
  ]


  return (
    <>
      {
        !isEmpty(trainingTypes) && <Box mb={2} display={'flex'} justifyContent={'end'} height={'100%'}>
          <Button onClick={() => dispatch(setTrainingTypeModal(true))} variant='contained' startIcon={<Add></Add>}>{t('newTrainingType')}</Button>
        </Box>
      }
      {(isLoading || isUserLoading) && <LinearProgress></LinearProgress>}
      <I18nDataGrid
        rows={trainingTypes}
        loading={false}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 5,
            },
          },
          columns: {
            columnVisibilityModel: {
              id: false
            }
          }
        }}
        slotProps={{
          toolbar: {
            showQuickFilter: true,
          },
        }}
        pageSizeOptions={[5]}
        checkboxSelection={false}
        disableRowSelectionOnClick
        slots={{
          noRowsOverlay: () => <Box display={'flex'} justifyContent={'center'} alignItems={'center'} height={'100%'}>
            <Button onClick={() => dispatch(setTrainingTypeModal(true))} variant='contained' startIcon={<Add></Add>}>{t('newTrainingType')}</Button>
          </Box>
        }}
      />
    </>
  )
}

export default MyTrainingTypes